/**
 * helpers.js — updated to use UTC-based timeline fields (depUTC / arrUTC)
 * produced by the timezone-aware engine.
 */

/**
 * Returns the first leg whose arrival busts the FDP end limit.
 */
export function findCriticalLeg({ timeline, dutyEndLimit }) {
  const bust = timeline.find((leg) => !leg.legal);
  return bust ? { leg: bust.leg } : null;
}

/**
 * Minutes between the last arrival (UTC) and the FDP end limit (UTC).
 * Positive = time remaining; negative = already over limit.
 */
export function calculateDelayMargin({ timeline, dutyEndLimit }) {
  const lastArr = timeline[timeline.length - 1].arrUTC;
  return Math.floor((dutyEndLimit - lastArr) / 60_000);
}